const style = {
  organizationSitesTab__tableBody: {
    '@media(min-height: 850px)': {
      height: 'calc(100vh - 802px)',
    },
  },
  organizationSitesTab__tableBody_noDashboard: {
    '@media(min-height: 480px)': {
      height: 'calc(100vh - 452px)',
    },
  },
};

export default style;
